import {NS_CONFIGURATION, PROJECT, EDITOR, TEMPLATE, CURRENT} from 'redux/constants';
import {action, createType, ASYNC, SYNC} from 'redux-create-type';


export const {
  INIT,
  SET_NAME,
  SET_ORDER,
  SET_APPLICABLE,
  INVALIDATE_CHANGES,
  SET_REMOVED,
  RESET_CHANGES,
  CHECK_VALIDATION,
  ADD_ITEM,
  REMOVE_ITEM,
  SET_ITEM_VALUE,
  EMPTY
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, TEMPLATE, CURRENT)({
  INIT: ASYNC,
  SET_NAME: SYNC,
  SET_ORDER: SYNC,
  SET_APPLICABLE: SYNC,
  INVALIDATE_CHANGES: SYNC,
  SET_REMOVED: SYNC,
  RESET_CHANGES: ASYNC,
  CHECK_VALIDATION: ASYNC,
  ADD_ITEM: ASYNC,
  REMOVE_ITEM: SYNC,
  SET_ITEM_VALUE: SYNC,
  EMPTY: SYNC,
});


export const init = {
  begin: localId => action(INIT.BEGIN, {localId}),
  end: ({selectedTemplate}) => action(INIT.END, {selectedTemplate}),
};
export const setName = name => action(SET_NAME, {name});
export const setOrder = order => action(SET_ORDER, {order});
export const setRemoved = value => action(SET_REMOVED, {value});
export const setApplicable = projectItemTypeConfigId => action(SET_APPLICABLE, { projectItemTypeConfigId });
export const invalidateChanges = ({changes}) => action(INVALIDATE_CHANGES, {changes});
export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({
          value,
        }) => action(RESET_CHANGES.END, {
    value,
  }),
};
export const checkValidation = {
  begin: () => action(CHECK_VALIDATION.BEGIN),
  end: ({errors}) => action(CHECK_VALIDATION.END, {errors})
};
export const removeItem = ({ item }) => action(REMOVE_ITEM, { item });
export const addItem = {
  begin: () => action(ADD_ITEM.BEGIN),
  end: ({ subItemOptions }) => action(ADD_ITEM.END, { subItemOptions })
};
export const setItemValue = ({ item, attribute, value }) => action(SET_ITEM_VALUE, { item, attribute, value });
export const empty = () => action(EMPTY);


// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/template/currentTemplate/actions.js